const percentsToNum = (percent) => parseFloat(percent);

const percentsToDecimal = (percent) => percentsToNum(percent) / 100.0;

// const decimalToPercents = (num) => `${Math.round(num * 100)}%`;
const decimalToPercents = (num) => `${Number((num * 100).toFixed(2))}%`;

export { percentsToDecimal, percentsToNum, decimalToPercents };
